module.exports = {
          srcSet: __webpack_public_path__ + "1bf0db9903d6b634ea91cf1c3c61555a-2920.png"+" 2920w",
          images:[ {path: __webpack_public_path__ + "1bf0db9903d6b634ea91cf1c3c61555a-2920.png",width: 2920,height: 2658}],
          src: __webpack_public_path__ + "1bf0db9903d6b634ea91cf1c3c61555a-2920.png",
          toString:function(){return __webpack_public_path__ + "1bf0db9903d6b634ea91cf1c3c61555a-2920.png"},
          
          width: 2920,
          height: 2658
        }